

import React from 'react';
import cx from 'classnames';
import { Checkbox, Input, RadioButton } from '../../../ui-kit';
import './styles/_changes-form.scss';

export const OTHER_REASON = 'Other';














function ChangesForm(props) {
  const {
    reasons,
    additionalReasonTitle,
    columns,
    multiple,
    allowOther,
    otherReason,
    selectedReasons,
    onCheck,
    onInputChange,
    hasComments
  } = props;

  const reasonsList = allowOther ? [...reasons, OTHER_REASON] : reasons;
  const CheckComponent = multiple ? Checkbox : RadioButton;
  const checkProp = multiple ? 'checked' : 'selected';
  const showReasonDueToNoComments = hasComments === false;

  return (
    <>
      <ul className={cx('changes-form__reasons', {
        'changes-form__reasons__columns': columns
      })}>

        {reasonsList.map((reason) =>
        <li
          key={reason}
          className="changes-form__reasons__item">

            <CheckComponent
            key={reason}
            {...{ [checkProp]: selectedReasons.includes(reason) }}
            onChange={onCheck(reason)}>

              {reason}
            </CheckComponent>
          </li>
        )}

      </ul>
      {allowOther && (selectedReasons.includes(OTHER_REASON) || showReasonDueToNoComments) &&
      <Input
        className="changes-form__additional-reason"
        label={additionalReasonTitle}
        value={otherReason}
        onChange={onInputChange}
        rows={4}
        multiline
        labelProps={{ required: true }} />}


    </>);

}

ChangesForm.defualtProps = {
  additionalReasonTitle: 'Reasons'
};

export default ChangesForm;